import NotificationCard from "./NotificationCard";

export default function LinkNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="link"
            destination={"/link/" + props.notification.file}
            showComments
        />
    );
}
